import { useMediaQuery } from '@mantine/hooks';
import { IconMenu2, IconSettings } from '@tabler/icons-react';
import { useCallback, useEffect, useState } from 'react';
import { Link as ReactRouterLink, useNavigate } from 'react-router-dom';
import { getOrgsForUser } from '../api/org';
import { getUserOrg } from '../api/user';
import { LanguageMenu } from '../i18n/LanguageMenu';
import { useLanguage } from '../i18n/LanguageProvider';
import { LogoutButton } from './auth/LogoutButton';
import { useOrgContext } from './org/OrgProvider';
import { useSidebarContext } from './sidebar/SidebarProvider';

const headerStyle: React.CSSProperties = {
  position: 'sticky',
  top: 0,
  zIndex: 100,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 16px',
  height: 56,
  background: '#ffffff',
  borderBottom: '1px solid #eef0f6',
};

export const Header = () => {
  const { messages } = useLanguage();
  const isMobile = useMediaQuery('(max-width: 767px)');

  return (
    <header style={headerStyle}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {isMobile && <MobileHamburger />}
        <ReactRouterLink
          to="/"
          style={{
            textDecoration: 'none',
            fontWeight: 700,
            fontSize: '1.1rem',
            color: '#0f172a',
            letterSpacing: '0.04em',
          }}
        >
          {messages.header.dabsi}
        </ReactRouterLink>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <AdminLink />
        <LanguageMenu color="#475569" />
        <LogoutButton color="#475569" />
      </div>
    </header>
  );
};

/** Admin link — only visible to superadmins */
const AdminLink = () => {
  const { userOrg } = useOrgContext();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (userOrg?.role === 'superadmin') {
      setShow(true);
      return;
    }
    if (userOrg) {
      setShow(false);
      return;
    }
    // No org context — check if superadmin in any org
    getOrgsForUser()
      .then(async orgs => {
        for (const org of orgs) {
          try {
            const uo = await getUserOrg(org.id);
            if (uo.role === 'superadmin') {
              setShow(true);
              return;
            }
          } catch {
            // skip
          }
        }
        setShow(false);
      })
      .catch(() => setShow(false));
  }, [userOrg]);

  if (!show) return null;

  return (
    <button
      type="button"
      onClick={() => navigate('/admin/pricing')}
      aria-label="Admin"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 36,
        height: 36,
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        borderRadius: 8,
        color: '#475569',
      }}
    >
      <IconSettings size={20} />
    </button>
  );
};

const MobileHamburger = () => {
  const { openMobile } = useSidebarContext();
  return (
    <button
      type="button"
      onClick={openMobile}
      aria-label="Open navigation"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 36,
        height: 36,
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        borderRadius: 8,
        color: '#334155',
      }}
    >
      <IconMenu2 size={22} />
    </button>
  );
};
